module.exports = __webpack_public_path__ + "static/media/headerweb.4b0c8d4c.png";